// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface IDetailProgressTagState {
  progress: number;
}

type IUpdateProgressAction = Action<'updateProgress'> & IPayload<number>;

export interface IDetailProgressTagModel {
  namespace: string;
  state: IDetailProgressTagState;
  effects: {};
  reducers: {
    updateProgress: Reducer<IDetailProgressTagState, IUpdateProgressAction>;
  };
}

export const DETAIL_PROGRESS_TAG_MODEL_NAMESPACE = 'dbg-model-detail-progress-tag';

const DetailProgressTagModel: IDetailProgressTagModel = {
  namespace: DETAIL_PROGRESS_TAG_MODEL_NAMESPACE,
  state: {
    progress: 0,
  },
  effects: {},
  reducers: {
    updateProgress(state, action) {
      return { ...state, progress: action?.payload ?? 0 };
    },
  },
};

export default DetailProgressTagModel;
